import * as cssVars from "css-vars-ponyfill"
import "./src/styles/app.scss"

export const onClientEntry = () => {
  cssVars.default()

  // Remove the 'no-js' class from the body
  window.addEventListener("load", () => {
    document.body.className = document.body.className.replace(/\bno-js\b/, "")
  })
}

export const onPreRouteUpdate = ({ location, prevLocation }) => {
  const BODY_LOCK = "util__body-lock"

  if (document.body.classList.contains(BODY_LOCK)) {
    document.body.classList.remove(BODY_LOCK)
  }

  window.scrollTo(0, 0)
}

export const onRouteUpdate = location => {
  if (location.location.hash) {
    setTimeout(() => {
      document.querySelector(`${location.location.hash}`).scrollIntoView()
    }, 0)
  }
}
